<div class="flex items-stretch justify-between gap-12 children:w-1/2 children:flex-1 ">
  <app-card>
    <div class="flex flex-col p-4">
      <div class="flex flex-row justify-between pb-4">
        <h5 id="h5-ballot-summary">Ballot Summary</h5>
        <app-ballot-status-badge
          [statusId]="ciBallotDetailDto?.ballotSummary?.unifiedBallotStatusId"></app-ballot-status-badge>
      </div>
      <div class="flex flex-col lg:flex-row lg:children:w-1/2 lg:gap-4">
        <div class="flex flex-col">
          <div id="div-ci-ballot-reference">
            <label for="p-ci-ballot-reference">Reference</label>
            <p class="body-default-regular" id="p-ci-ballot-reference">
              {{ ciBallotDetailDto?.ballotSummary?.reference }}
            </p>
          </div>
          <div id="div-ci-ballot-question">
            <label for="p-ci-ballot-question">Question</label>
            <p class="body-default-regular" id="p-ci-ballot-question">
              {{ ciBallotDetailDto?.ballotSummary?.question }}
            </p>
          </div>
          <div id="div-ci-ballot-committee">
            <label for="a-ci-ballot-committee">Committee</label>
            <p class="body-default-regular">
              <a class="body-default-regular text-link" id="a-ci-ballot-committee" [routerLink]="[
                '/committees',
                ciBallotDetailDto?.ballotSummary?.committeeCode
              ]">
                {{ ciBallotDetailDto?.ballotSummary?.committeeCode }}
                {{ ciBallotDetailDto?.ballotSummary?.committeeTitle }}
              </a>
            </p>
          </div>

          <div id="div-ci-ballot-project-manager">
            <label for="a-ci-ballot-project-manager">Lead</label>
            <p class="body-default-regular">
              <a class="body-default-regular text-link" id="a-ci-ballot-project-manager" href="mailto:{{
                ciBallotDetailDto?.ballotSummary?.projectManagerEmail
              }}">
                {{ ciBallotDetailDto?.ballotSummary?.projectManagerName }}
              </a>
            </p>
          </div>
          <div id="div-ci-ballot-associated-documents">
            <label for="a-ci-ballot-associated-documents">Associated Documents</label>
            <p class="body-default-regular">
              <a class="cursor-pointer body-default-regular text-link" id="a-ci-ballot-associated-documents"
                (click)="downloadAssociatedDocument($event)">
                {{
                ciBallotDetailDto?.supportingDocument?.metadata?.filename
                | displayDash
                }}
              </a>
            </p>
          </div>
        </div>

        <form [formGroup]="ballotDateFormGroup">
          <div class="flex flex-col">
            <div id="div-ci-ballot-start-date">
              <ng-container *ngIf="canEditStartDate; else displayStartDate">
                <app-date-picker formControlName="ballotStartDateCtrl" id="ballot-start-date" name="startDate"
                  label="Start Date" placeholder="Select date" [minDate]="minStartDate" [maxDate]="maxStartDate"
                  [isFromBallotSummary]="true">
                </app-date-picker>
              </ng-container>
              <ng-template #displayStartDate>
                <label for="p-ci-ballot-start-date">Start Date</label>
                <p class="body-default-regular" id="ballot-start-date-input">
                  {{
                  ciBallotDetailDto?.ballotSummary?.startDate
                  | dateFormat
                  }}
                </p>
              </ng-template>
            </div>
            <div id="div-ci-ballot-end-date">
              <ng-container *ngIf="canEditEndDate; else displayEndDate">
                <app-date-picker formControlName="ballotEndDateCtrl" id="ballot-end-date" name="endDate"
                  label="End Date" placeholder="Select date" [minDate]="minEndDate" [isFromBallotSummary]="true">
                </app-date-picker>
              </ng-container>
              <ng-template #displayEndDate>
                <label for="p-ci-ballot-end-date">End Date</label>
                <p class="body-default-regular" id="ballot-end-date-input">
                  {{
                  ciBallotDetailDto?.ballotSummary?.endDate
                  | dateFormat
                  }}
                </p>
              </ng-template>
            </div>
          </div>
        </form>
      </div>

      <div class="my-4 border-b border-gray-200"></div>

      <form [formGroup]="ballotNoteFormGroup">
        <div class="flex flex-col children:w-full">
          <label for="ci-ballot-note">Notes</label>
          <div *ngIf="!isUserPmOrAbove" class="ballot-summary-value">{{ballotNoteCtrl?.value??''}}</div>
          <app-text-area *ngIf="isUserPmOrAbove" id="ci-ballot-note" title="Note" formControlName="ballotNoteCtrl" [rows]="6"></app-text-area>
        </div>
      </form>

      <div *ngIf="isVotingActionsVisible">
        <div class="my-4 border-b border-gray-200"></div>

        <div class="mb-4 body-default-bold">My Vote</div>

        <div *ngIf="!hasVoted">No vote placed</div>
        <div *ngIf="hasVoted" class="flex flex-row items-center">
          <span class="mr-2 material-symbols-rounded"
            [ngStyle]="{'color': userVoteOption?.color}">{{userVoteOption?.icon}}</span>
          <span class="body-default-bold" id="user-current-vote">{{userVoteOption?.text}}</span>
          <span id="user-vote-created-date">&nbsp;-&nbsp;placed on {{userVoteSubmittedDate}}</span>
        </div>

        <div id="voting-action" class="flex flex-row gap-4 mt-4" *ngIf="!isInternalPublicUser">

          <button class="w-1/6 btn btn-primary h-[50px]" [disabled]="!isVoteButtonEnable" (click)="openPlaceVoteModal()"
            id="place-vote-Button">{{hasVoted ? 'Change Vote' : 'Place Vote'}}</button>

        </div>
      </div>

    </div>
  </app-card>
  <app-card>
    <div class="flex flex-col w-full">
      <app-ci-eligible-voters [ballotVotes]="this.ciBallotDetailDto?.committeeMembers??[]" [isJoint] = "false" [BallotStatus] = "this.ciBallotDetailDto?.ballotSummary?.unifiedBallotStatusId" [ciBallotDetailDto] = "ciBallotDetailDto"></app-ci-eligible-voters>
    </div>
  </app-card>
</div>
